import React from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import {
  MCoach as MCoachIcon,
  Playlist as PlaylistIcon,
  SkillBites as SkillBitesIcon
} from '../../app-toolbar-paid-consumer/icons'
import { useMindset } from '../../mindset-agent/mindset-context'
import { routes } from '../../../router/routes'
import { BaseNotificationModal } from './base-modal'
import { useStyles } from './style'

const ICON_SIZE = 22

const ToolRow = ({ icon, tileClass, title, body, onClick, dataTest }) => {
  const classes = useStyles()
  return (
    <Box component='button' onClick={onClick} className={classes.toolRow} data-test={dataTest}>
      <Box className={`${classes.toolTile} ${tileClass}`} aria-hidden='true'>
        {icon}
      </Box>
      <Box>
        <Typography className={classes.rowTitle}>{title}</Typography>
        <Typography variant='body2' color='textSecondary'>{body}</Typography>
      </Box>
    </Box>
  )
}

/* Feature-discovery tour — the three core tools, each row goes straight to the
 * tool. Tile colours mirror the marketing site's tool cards. */
export const WelcomeTourModal = ({ open, onClose }) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { openMindset } = useMindset()

  const go = fn => () => {
    onClose()
    fn()
  }

  return (
    <BaseNotificationModal open={open} onClose={onClose} title='Get to know your tools' dataTest='notification-modal-welcome-tour'>
      <Typography color='textSecondary' className={classes.intro}>
        These are the three tools people reach for every day — tap one to try it now.
      </Typography>
      <ToolRow
        icon={<MCoachIcon width={ICON_SIZE} height={ICON_SIZE} />}
        tileClass={classes.toolTileMcoach}
        title='M:Coach'
        body='Your AI coach — ask anything, from tricky feedback to career moves.'
        onClick={go(() => openMindset({ from: 'notification-welcome-tour' }))}
        dataTest='notification-welcome-tool-mcoach'
      />
      <ToolRow
        icon={<SkillBitesIcon width={ICON_SIZE} height={ICON_SIZE} />}
        tileClass={classes.toolTileSkillBites}
        title='Skill Bites'
        body='Bite-size interactive sessions, 10 minutes at a time.'
        onClick={go(() => navigate(routes['skill-bites'].path))}
        dataTest='notification-welcome-tool-skill-bites'
      />
      <ToolRow
        icon={<PlaylistIcon width={ICON_SIZE} height={ICON_SIZE} />}
        tileClass={classes.toolTilePlaylists}
        title='Playlists'
        body='Curate your own learning path, or follow one built for you.'
        onClick={go(() => navigate(routes.playlists.path))}
        dataTest='notification-welcome-tool-playlists'
      />
    </BaseNotificationModal>
  )
}

export default WelcomeTourModal
